module.exports = __webpack_public_path__ + "h5/img/offer_2025.fc89da54.png";